import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button, InputNumber } from "antd";
import { useEffect, useRef, useState } from "react";

import bl1 from "../images/bl/bl1.png";
import bl2 from "../images/bl/bl2.png";
import bl3 from "../images/bl/bl3.png";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { TestUIBl } from "./TestUI";

const PosturalExamBalance_DoExam = ({
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setTestSelection,
}: {
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
}) => {
  const ref1 = useRef<any>();
  const ref2 = useRef<any>();
  const ref3 = useRef<any>();

  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 640 && (
        <div className="centered">
          <Row>
            <Col span={8}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={bl1}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || bl1}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(0)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={16}>
              <TestUIBl
                testDefinition={
                  testDefinitions.length > 0 ? testDefinitions[0] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 0
                    ? posturalExamination.testSelections[0]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "32px" }}>
            <Col span={8}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={bl2}
                  preview={
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 2 && images[1].url) || bl2}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(1)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref2.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref2}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(1, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                      ? images[1].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 2 && images[1].url != photoNotTakenYet.url ? (
                  images[1].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={16}>
              <TestUIBl
                testDefinition={
                  testDefinitions.length > 1 ? testDefinitions[1] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 1
                    ? posturalExamination.testSelections[1]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "32px" }}>
            <Col span={8}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={bl3}
                  preview={
                    images.length >= 3 && images[2].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 3 && images[2].url) || bl3}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(2)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref3.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(2, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 3 && images[2].url != photoNotTakenYet.url
                      ? images[2].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 3 && images[2].url != photoNotTakenYet.url ? (
                  images[2].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={16}>
              <TestUIBl
                testDefinition={
                  testDefinitions.length > 2 ? testDefinitions[2] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 2
                    ? posturalExamination.testSelections[2]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
        </div>
      )}
      {width <= 640 && (
        <div className="centrados">
          <Row>
            <Col span={8}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={bl1}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || bl1}
                />
              </div>

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={16}>
              <TestUIBl
                testDefinition={
                  testDefinitions.length > 0 ? testDefinitions[0] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 0
                    ? posturalExamination.testSelections[0]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "32px" }}>
            <Col span={8}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={bl2}
                  preview={
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 2 && images[1].url) || bl2}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(1)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref2.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref2}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(1, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 2 && images[1].url != photoNotTakenYet.url
                      ? images[1].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 2 && images[1].url != photoNotTakenYet.url ? (
                  images[1].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={16}>
              <TestUIBl
                testDefinition={
                  testDefinitions.length > 1 ? testDefinitions[1] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 1
                    ? posturalExamination.testSelections[1]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "32px" }}>
            <Col span={8}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={bl3}
                  preview={
                    images.length >= 3 && images[2].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 3 && images[2].url) || bl3}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(2)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref3.current?.click()}
              >
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref3}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(2, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 3 && images[2].url != photoNotTakenYet.url
                      ? images[2].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 3 && images[2].url != photoNotTakenYet.url ? (
                  images[2].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={16}>
              <TestUIBl
                testDefinition={
                  testDefinitions.length > 2 ? testDefinitions[2] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 2
                    ? posturalExamination.testSelections[2]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

const PosturalExamBalanceRight = ({
  page,
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setTestSelection,
}: {
  page: number;
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);
  return (
    <>
      {page == 0 && (
        <PosturalExamBalance_DoExam
          images={images}
          getWebcamPhoto={getWebcamPhoto}
          loadPhoto={loadPhoto}
          testDefinitions={testDefinitions}
          posturalExamination={posturalExamination}
          setTestSelection={setTestSelection}
        />
      )}
    </>
  );
};

export default PosturalExamBalanceRight;
